{
  "ERROR_INPUT": {
    "SMS_MOBILE_NUMBER": "This phone number cannot receive the SMS notifying your customer. Enter a French mobile number starting with 06 or 07, or select the \"CALL\" option."
  },
  "STORE_PRICING_SETTINGS": {
    "SHOW_COST_DETAILS": "Show the package cost breakdown on hover",
    "ALLOW_CODE_ADJUSTMENT": "Show the package adjustment code field"
  },
  "repairFileWorkflow": {
    "steps": {
      "availability": "Customer notified of availability",
      "customerReturn": "Return transport to customer"
    },
    "declaration": {
      "option": "Declared decision (optional)",
      "recipient": "Declared sending recipient",
      "optionalDecision": "Without a decision, the stage is recorded without transmission evidence. The selected date is the declared date."
    },
    "title": "Your next actions",
    "nextAction": "YOUR NEXT ACTION: {action}",
    "pastAction": "ACTION AT THIS STEP: {action}",
    "noValue": "Not provided",
    "remindersActive": "Automatic reminders enabled.",
    "remindersActiveSince": "Automatic reminders enabled since {date}.",
    "options": {
      "OPTION_1": "Repair package",
      "OPTION_2": "Diagnosis and estimate",
      "OPTION_3": "Recycling",
      "CREDIT_OR_REFUND": "Credit / refund",
      "PRODUCT_REPLACEMENT": "Replacement with a new product",
      "PRODUCT_REPAIR_WITHOUT_GUARANTEE": "Product return requested for diagnosis",
      "PRODUCT_REPAIR_WITH_GUARANTEE": "Repair under warranty",
      "TECHNICIAN_ON_SITE_INTERVENTION": "On-site technician intervention",
      "REJECT_PROSPECT": "Support request rejected",
      "OTHER": "Other",
      "DIAGNOSIS": "Diagnosis and estimate",
      "ON_SITE": "On-site technician intervention"
    },
    "events": {
      "PRELIMINARY_INFORMATION_RECEIVED": "ADDITIONAL INFORMATION ABOUT THE REPAIRER RESPONSE. Request number: {request_number}. Comment: {comment}",
      "FILE_CLOSED_DECLARED": "12. FILE MANUALLY CLOSED by {actor} on {date}. This closure does not imply customer receipt confirmation.",
      "CUSTOMER_AVAILABILITY_DECLARED": "11a. CUSTOMER AVAILABILITY NOTIFICATION DECLARED by {actor}. Product available at {depot}.",
      "CUSTOMER_DECISION_FORWARDED_TO_STORE": "7. DECISION FORWARDED BY SYSTEM TO STORE at {recipient}: {option}. Sending to the repairer still needs to be declared.",
      "BREAKDOWN_REPORTED": "ISSUE REPORTED by {actor}: {description}.",
      "FILE_CREATION_STARTED": "1. FILE BEING CREATED at {depot}.",
      "PACKAGE_PROPOSAL_SENT": "PACKAGE PROPOSAL SENT to {recipient}. WAITING FOR CUSTOMER: service option selection.",
      "PACKAGE_DECISION_RECEIVED": "CUSTOMER DECISION RECEIVED BY EMAIL: {option}.",
      "PRELIMINARY_REQUEST_SENT": "PRELIMINARY REQUEST SENT to {recipient}. Request number: {request_number}. WAITING FOR REPAIRER: acceptance decision.",
      "PRELIMINARY_RESPONSE_RECEIVED": "REPAIRER RESPONSE RECEIVED BY EMAIL: {option}. Request number: {request_number}.",
      "PRELIMINARY_RESPONSE_DECLARED": "REPAIRER RESPONSE DECLARED by {actor}: {option}. Request number: {request_number}.",
      "TRANSPORT_LABELS_REQUESTED": "SHIPPING LABELS REQUESTED from {recipient}. WAITING FOR PARTNER: label issuance.",
      "OUTBOUND_TRANSPORT_STARTED": "2. OUTBOUND TRANSPORT INITIATED: {departure} to {repairer} since {date}. WAITING: collection and repairer receipt confirmation.",
      "REPAIRER_RECEIPT_RECORDED": "3. PRODUCT RECEIVED AT {repairer} since {date}. WAITING FOR REPAIRER: diagnosis and service proposal.",
      "REPAIRER_ESTIMATE_REPORTED_SENT": "4. REPAIRER ESTIMATE SENT to {recipient} since {date}.",
      "REPAIRER_ESTIMATE_INTEGRATED": "5. REPAIRER ESTIMATE ADDED TO THE FILE.",
      "CUSTOMER_ESTIMATE_SENT": "6. ESTIMATE SENT TO {recipient} BY THE SYSTEM. WAITING FOR CUSTOMER: estimate decision.",
      "CUSTOMER_ESTIMATE_SEND_DECLARED": "6. ESTIMATE SENDING DECLARED by {actor} on {date}. Recipient: {recipient}. No platform sending or automatic reminders. WAITING FOR CUSTOMER: estimate decision.",
      "CUSTOMER_DECISION_SENT_TO_REPAIRER": "7. CUSTOMER DECISION RECEIVED AND SENT TO THE REPAIRER BY THE SYSTEM: {option}. WAITING FOR REPAIRER: processing.",
      "CUSTOMER_DECISION_SEND_DECLARED": "7. DECISION SENDING TO THE REPAIRER DECLARED by {actor}: {option}. No customer email approval recorded in the platform.",
      "CUSTOMER_DECISION_TRANSMISSION_UNVERIFIED": "7. DECISION TRANSMISSION DECLARED WITHOUT PLATFORM SENDING.",
      "REPAIR_STARTED": "8. REPAIR IN PROGRESS at {repairer} since {date}. WAITING FOR REPAIRER: work completion.",
      "REPAIR_PARTS_ORDERED": "8. PARTS ORDERED by {repairer} since {date}. WAITING: parts delivery to continue the repair.",
      "REPAIRER_RETURN_STARTED": "9. RETURN TRANSPORT INITIATED BY {repairer} to {destination}. WAITING FOR RECIPIENT: receipt confirmation.",
      "NO_RETURN_TREATMENT_FINALIZED": "9. TREATMENT FINALIZED BY {repairer}: {option}.",
      "DEPOT_RECEIPT_RECORDED": "10. PRODUCT RECEIVED AT DEPOT {depot}.",
      "CUSTOMER_AVAILABILITY_NOTIFIED": "11a. CUSTOMER NOTIFIED OF PRODUCT AVAILABILITY AT {depot}. WAITING FOR CUSTOMER: collection.",
      "CUSTOMER_RETURN_DISPATCHED": "11b. RETURN TRANSPORT TO {customer_site} INITIATED. WAITING FOR CUSTOMER: receipt confirmation after delivery.",
      "FILE_CLOSED_WITH_RETURN": "12. HANDOVER / RECEIPT DECLARED BY {actor} on {date}. FILE CLOSED. Outcome: {option}.",
      "FILE_CLOSED_WITHOUT_RETURN": "12. TREATMENT WITHOUT RETURN FINALIZED: {option}. FILE CLOSED.",
      "BILLING_STAGE_ENTERED": "13. BILLING.",
      "FILE_FINISHED": "14. FILE FINISHED. Intervention closed and file processing finalized.",
      "PACKAGE_PROPOSAL_QUEUED": "Package proposal prepared. Customer email pending.",
      "PRELIMINARY_REQUEST_QUEUED": "Preliminary request prepared. Repairer email pending.",
      "CUSTOMER_ESTIMATE_QUEUED": "Estimate prepared. Customer email pending.",
      "CUSTOMER_DECISION_QUEUED": "Decision recorded: {option}. Platform transmission pending.",
      "CUSTOMER_RETURN_DELIVERED": "The carrier reports customer delivery on {date}. Closure remains manual.",
      "CUSTOMER_RECEIPT_SMS_SENT": "Product receipt confirmation SMS sent to {phone} on {date}.",
      "CUSTOMER_RECEIPT_CONFIRMED": "The customer confirms product receipt on {date}. Attached photo: Returned product customer photo. Customer comment: {comment}",
      "FILE_ABANDONED": "File abandoned by the customer.",
      "FILE_DELETED": "File deleted."
    },
    "actionOverrides": {
      "PACKAGE_DECISION_RECEIVED": {
        "CONTINUE_FILE_AND_FINALIZE_TRANSPORT": "Continue the file and arrange transport if necessary."
      }
    },
    "actions": {
      "COMPLETE_REPAIR_FILE": "Complete the file and finalize service arrangements.",
      "CONTINUE_FILE_AND_FINALIZE_TRANSPORT": "Continue the file and finalize transport if needed.",
      "CONTINUE_FILE_FROM_REPAIRER_RESPONSE": "Continue the file based on this response.",
      "INTEGRATE_AND_SEND_CUSTOMER_ESTIMATE": "Add the estimate and send it to the customer.",
      "ENTER_ERP_BILLING": "Enter billing in the ERP.",
      "DESCRIBE_DECISION_TRANSMISSION": "Specify the decision, recipient and transmission date in a comment.",
      "FINALIZE_FILE_FOR_OUTCOME": "Finalize the file according to the selected outcome.",
      "INFORM_CUSTOMER_OR_ARRANGE_RETURN": "Notify the customer of availability or arrange return to their site.",
      "FINALIZE_BILLING_AND_FINISH_FILE": "Finalize billing, then finish the file."
    }
  },
  "EMAIL_OUTBOX_TYPE": {
    "REPAIRER_ESTIMATE_RECEIPT_FOLLOWUP": "Customer decision receipt confirmation - repairer follow-up",
    "FORGOT_PASSWORD": "Forgotten password",
    "INITIALIZATION_PASSWORD": "Password initialization",
    "ACCOUNT_CREATION_CONFIRMATION": "Account creation confirmation",
    "RENTAL_FILE_CREATED": "Rental file created",
    "RENTAL_STORE_RECEIPT": "Rental received at store",
    "RECYCLING_CERTIFICATE": "Recycling certificate",
    "RECYCLING_COLLECTION_NOTIFICATION": "Recycling collection notification",
    "PUBLIC_ACCOUNT_CREATION_REQUESTER": "Account request - requester",
    "PUBLIC_ACCOUNT_CREATION_ADMIN": "Account request - admin",
    "GUARANTEE_EXTENSION": "Warranty extension",
    "DOCUMENT_BY_EMAIL": "Repair file documents",
    "LOGIN_2FA": "2FA login code",
    "REPAIR_FILE_TRANSPORT_REPAIRER": "Repairer transport request",
    "REPAIR_FILE_REMINDER_REPAIRER": "Repairer reminder",
    "REPAIR_FILE_RECEIPT_AT_STORE": "Repair file received at store",
    "MANUFACTURER_ESTIMATE_STORE": "Manufacturer estimate sent - store notification",
    "RECEIPT_AT_STORE_PICKUP_RELAUNCH": "Store receipt reminder - customer pickup",
    "RECEIPT_AT_STORE_SENT_BY_STORE_RELAUNCH": "Store receipt reminder - store delivery",
    "ESTIMATE_PACKAGE_CLIENT": "Customer package estimate",
    "ESTIMATE_PACKAGE_CLIENT_RELAUNCH": "Customer package estimate reminder",
    "ESTIMATE_PACKAGE_CHOICE_STORE": "Store package choice",
    "REPAIRER_ESTIMATE_CLIENT": "Customer repairer estimate",
    "REPAIRER_ESTIMATE_CLIENT_RELAUNCH": "Customer repairer estimate reminder",
    "NEW_REPAIRER_ESTIMATE_CLIENT": "New customer repairer estimate",
    "REPAIRER_ESTIMATE_CHOICE_CLIENT": "Customer estimate choice",
    "REPAIRER_ESTIMATE_CHOICE_REPAIRER": "Repairer estimate choice",
    "REPAIRER_ESTIMATE_CHOICE_STORE": "Store repairer estimate choice",
    "REPAIRER_ESTIMATE_PURCHASE_ORDER_STORE": "Store repairer estimate purchase order",
    "PROSPECT_REQUEST_REPAIRER": "Repairer preliminary request",
    "PROSPECT_RESPONSE_STORE": "Store preliminary request response",
    "PROSPECT_MANUFACTURER_SELECTION_STORE": "Store preliminary request manufacturer selection",
    "REPAIR_FILE_SHARE_CLIENT": "Repair file shared with customer",
    "REPAIR_FILE_SHARE_PREPARER": "Repair file shared with preparer",
    "REPAIR_FILE_SHARE_COMMERCIAL": "Repair file shared with sales representative",
    "REPAIR_FILE_SATISFACTION_QUESTIONNAIRE": "Repair file satisfaction survey",
    "ADMIN_RELAUNCH_STATUS_CONFIRMATION": "Admin status follow-up confirmation",
    "IMPORT_SUCCESS": "Import successful",
    "IMPORT_ERROR": "Import failed",
    "EXPORT_SUCCESS": "Export successful",
    "EXPORT_ERROR": "Export failed",
    "NAMEPLATE_REPAIR_REQUEST": "Nameplate repair request",
    "KEY_ACCOUNT_PRODUCT_REQUEST_ADMIN": "Key account product creation request - admin",
    "KEY_ACCOUNT_PRODUCT_REQUEST_APPROVED": "Key account product creation request approved",
    "KEY_ACCOUNT_PRODUCT_REQUEST_DENIED": "Key account product creation request declined",
    "KEY_ACCOUNT_PRODUCT_REQUEST_AWAITING_INFORMATION": "Key account product creation request - awaiting information",
    "KEY_ACCOUNT_PRODUCT_REQUEST_DRAFT_SHARE": "Key account product creation request shared",
    "PICKUP_REQUEST": "Repair pickup request",
    "CLOUD_STORAGE_INTEGRITY_RESULT": "Cloud storage integrity check result",
    "PRODUCT_CREATION_REQUEST": "Product creation request"
  },
  "CUSTOMER_RECEIPT": {
    "TITLE": "Confirm receipt of your product",
    "INSTRUCTIONS": "To initiate your warranty extension, please take a photo of the nameplate on the product you have received.",
    "PHOTO_LABEL": "Nameplate photo (required)",
    "DROPZONE_TITLE": "Add a photo of the nameplate",
    "PHOTO_HINT": "JPG or PNG · Maximum 10 MB",
    "TAKE_PHOTO": "Take a photo",
    "INVALID_PHOTO": "Please select a JPG or PNG photo.",
    "PHOTO_SIZE": "The photo must not be empty or exceed 10 MB.",
    "COMMENT_LABEL": "Comment (optional)",
    "COMMENT_PLACEHOLDER": "Anything to add about receiving your product?",
    "CONFIRM": "Confirm receipt of my product",
    "SUCCESS_TITLE": "Receipt confirmed",
    "SUCCESS_MESSAGE": "Thank you! Your product receipt and photo have been recorded."
  },
  "welcome": "welcome",
  "ATTACHMENT_UPLOAD": {
    "FROM_COMPUTER": "From computer",
    "VIA_MOBILE": "Via mobile",
    "LOAD_FAILED": "Unable to load the mobile upload link.",
    "RETRY": "Try again",
    "MISSING": "The file has not been uploaded yet.",
    "CONFIRM": "Confirm upload"
  },
  "ERROR": {
    "SMS_NOTIFICATION_FAILED_ERROR": "The SMS could not be sent. Please try again.",
    "SMS_SERVICE_UNAVAILABLE_ERROR": "SMS notifications are unavailable. Please try again later or choose another notification method.",
    "INVALID_RENTAL_FILE_PRODUCT_AVAILABILITY_ERROR": "This product is no longer available for rental. Please select another product."
  },
  "hello": "hello",
  "FINALIZATION_PAGE": {
    "TITLE": "Finalization of repair file No. {number}",
    "SUBTITLE": "Follow the 3 mandatory steps below to activate tracking for your repair. None can be skipped.",
    "SUBTITLE_WITHOUT_TRACKING": "Follow the 3 steps below to activate tracking for your repair.",
    "REPAIRER_NUMBER": "Repairer number",
    "REPAIRER_NUMBER_PLACEHOLDER": "Enter the number",
    "DOWNLOAD": "Download",
    "REDOWNLOAD": "Re-download",
    "TRACKING_NUMBER": "Tracking number",
    "TRACKING_NUMBER_PLACEHOLDER": "XR123456789FR",
    "FINISH_LATER": "Finish later",
    "ACTIVATE_TRACKING": "Activate repair-file tracking",
    "SECTIONS": {
      "TRANSPORT_DETAILS": "Enter transport information",
      "DOCUMENTS": "Print the documents for the repairer",
      "DOCUMENTS_SUBTITLE": "These documents must be placed inside the parcel. Without them, your product cannot be handled or repaired by the technician.",
      "ACTIVATE_TRACKING": "Activate repair-file tracking",
      "ACTIVATE_TRACKING_SUBTITLE": "By confirming, you declare that you have entered the tracking number and placed all documents inside the parcel. Tracking for your repair will then be activated.",
      "ACTIVATE_WITHOUT_TRACKING_SUBTITLE": "By confirming, you declare that you have placed all documents inside the parcel. Tracking for your repair will then be activated."
    },
    "DOCUMENTS_INCLUDED": {
      "REPAIR_ORDER": "Repair order",
      "GUARANTEE_EXTENSION_PROOF": "Guarantee extension proof",
      "PURCHASE_PROOF": "Purchase proof",
      "ASBESTOS_PROOF": "Asbestos proof",
      "FORCE_SUPPORT_PROOF": "Forced support proof",
      "BATTERY_LABEL": "Battery label",
      "TRANSPORT_LABEL": "Transport label",
      "TRANSPORTER_REPAIRER_DOCUMENT": "Transporter document for the repairer"
    },
    "DOCUMENT_PLACEMENTS": {
      "STICK_ON_PARCEL": "Stick on the parcel",
      "PUT_IN_PARCEL": "Put inside the parcel"
    },
    "MESSAGE": {
      "LOAD_ERROR": "The repair file or document list could not be loaded.",
      "SUCCESS": "Repair file finalized"
    }
  },
  "RENTAL_FILE_WELCOME": {
    "TITLE": "Welcome to Boomerang rental",
    "SUBTITLE": "Find a rental power tool to use while your equipment is being repaired.",
    "EMPTY": "No products match your search and selected availability.",
    "LOAD_ERROR": "Rental products could not be loaded. Please try again.",
    "FIND_PRODUCT": "Find your product",
    "SELECT_ALL": "View all",
    "AVAILABILITY_STATUS_GROUP": "Availability",
    "AVAILABILITY_STATUS": {
      "AVAILABLE": "Available",
      "IN_COMING": "Coming soon",
      "UNAVAILABLE": "Unavailable"
    }
  },
  "RENTAL_PRODUCT_DETAIL": {
    "TITLE": "Rental product details",
    "SERIAL_NUMBER": "Serial number: {number}",
    "RENTAL_PRICE": "Rental price excluding VAT",
    "PRODUCT_SHEET": "Product information",
    "SPECIFICATIONS": "Specifications",
    "CONSUMABLE_REFERENCE": "Ref. {reference}",
    "CONTRACT_DETAILS_HINT": "Contract details will be requested when creating the rental file.",
    "FIELDS": {
      "BRAND": "Brand",
      "CATEGORY": "Category",
      "MODEL": "Model",
      "REFERENCE": "Reference",
      "SUB_CATEGORY": "Subcategory",
      "WEIGHT": "Weight",
      "LENGTH": "Length",
      "WIDTH": "Width"
    },
    "NO_PICTURE": "Product picture unavailable",
    "CONSUMABLE_PICTURE": "Consumable picture"
  },
  "RENTAL_FILE_CREATE": {
    "LOAD_ERROR": "The rental form could not be loaded. Please try again.",
    "DATE_ERROR": "Select a valid delivery date, today or later.",
    "SAME_BILLING_ADDRESS": "Billing address is the same as delivery address",
    "SECTIONS": {
      "DELIVERY_ADDRESS": "Delivery address",
      "BILLING_ADDRESS": "Billing address",
      "DELIVERY_DEPOSIT": "Delivery and deposit",
      "ADDITIONAL_INFORMATION": "Additional information"
    }
  },
  "COMMON": {
    "PRELIMINARY_REQUEST": "Preliminary request",
    "GUARANTEE": {
      "TITLE": "Warranty",
      "ALL": "All",
      "UNDER_GUARANTEE": "Under warranty",
      "NOT_GUARANTEE": "Out of warranty",
      "UNDEFINED": "Not specified"
    },
    "EAN": "EAN / Sales barcode",
    "EAN_DIGITS_ONLY": "EAN must contain digits only.",
    "ORDER_NUMBER": "Order number",
    "COST": "Cost",
    "COST_EXCLUSIVE_TAX": "Cost (excl. tax)",
    "NO_DATA": "No data available",
    "LOADING": "Loading…",
    "PUBLIC_PAGE": {
      "LOADING": "Loading…",
      "INVALID_TITLE": "This link is no longer valid",
      "INVALID_MESSAGE": "This link is invalid, expired or already used. Please request a new link.",
      "FAILED_TITLE": "Unable to load this page",
      "FAILED_MESSAGE": "Please check your connection and try again.",
      "RETRY": "Try again"
    },
    "PUBLIC_UPLOAD": {
      "CAPACITY": "{count} / {max} photos uploaded. You can add {remaining} more.",
      "PARTIAL": "Some photos could not be uploaded. Retry the remaining photos.",
      "FAILED_FILES": "Photos to retry: {names}",
      "MAX_SIZE": "Maximum size per file: {size} {unit}",
      "MEGABYTE": "MB",
      "TOO_LARGE": "A selected file exceeds the maximum size.",
      "OVER_CAPACITY": "Too many photos selected. Remove photos to stay within the remaining capacity.",
      "DROPZONE": "Drag a document here or select a file",
      "RELAUNCH_FORMATS": "Accepted formats: PDF, JPG, PNG",
      "REMOVE": "Remove file"
    },
    "ADDRESS_FIELDS": {
      "NAME": "Address name",
      "NUMBER": "Number",
      "STREET": "Street",
      "ZIP_CODE": "Postal code",
      "CITY": "City",
      "COUNTRY": "Country"
    },
    "REQUIRED": "Required",
    "BUTTON": {
      "RETRY": "Retry",
      "BACK": "Back",
      "CLOSE": "Close",
      "CANCEL": "Cancel",
      "REMOVE": "Remove",
      "SEND": "Send",
      "VALIDATE": "Validate"
    },
    "FILE_UPLOAD": {
      "INVALID_FORMAT": "This file format is not accepted."
    },
    "PLACEHOLDER": {
      "FILE_NAME": "File name"
    }
  },
  "REPAIR_FILE_ATTACHMENT": {
    "MODAL": {
      "ACCEPTED_FORMATS": "Accepted formats: PDF, JPG, PNG, JPEG",
      "FILE": "Add your attachment",
      "FILE_NAME": "File name",
      "GENERIC_TITLE": "Add an attachment",
      "QR_CODE_SUBTITLE": "Scan this QR code with a mobile device to add the attachment.",
      "QR_CODE_TITLE": "Add an attachment with a QR code",
      "QR_CONFIRM": "I added the document",
      "QR_UPLOAD_MISSING": "No document has been added with the QR code yet.",
      "SUBTITLE": "Add a file from this computer or generate a QR code to add it from a mobile device.",
      "UPLOAD_VIA_MOBILE": "Add with QR code"
    },
    "PLACEHOLDER": {
      "FILE_NAME": "File name"
    }
  },
  "ATTACHMENT_MODAL": {
    "QR_CODE_PAGE": {
      "ACCEPTED_FORMATS": "Accepted formats: PDF, JPG, PNG, JPEG",
      "DROPZONE_TITLE": "Drop the document here",
      "HINT": "The document will be attached to the file after confirmation on the computer.",
      "MESSAGE_ERROR_TOKEN_VALIDITY": "Request a new QR code from the file.",
      "MESSAGE_SENT": "You can return to the computer and confirm the upload.",
      "REMOVE_FILE": "Remove document",
      "SUBTITLE": "Add the document from your mobile device.",
      "TAKE_PHOTO": "Take a photo",
      "TITLE": "Add an attachment",
      "TITLE_ERROR_TOKEN_VALIDITY": "Expired or invalid link",
      "TITLE_SENT": "Document sent"
    }
  },
  "RENTAL_FILE_ATTACHMENT": {
    "CARD": {
      "ADD_ATTACHMENT": "Add an attachment"
    },
    "MODAL": {
      "ACCEPTED_FORMATS": "Accepted formats: PDF, JPG, PNG, JPEG",
      "FILE": "Add your attachment",
      "FILE_NAME": "File name"
    }
  },
  "RENTAL_FILE_ADD_PICTURE": {
    "ACCEPTED_FORMATS": "Accepted formats: JPG, JPEG, PNG",
    "ADD_PHOTO": "Add a photo",
    "DROPZONE_TITLE": "Drop your photos here",
    "HINT": "Add one or more clear photos of the product.",
    "MESSAGE": "Add one or more photos of the product.",
    "MESSAGE_ERROR_TOKEN_VALIDITY": "Request a new QR code from the Boomerang platform.",
    "MESSAGE_SENT": "You can now continue on the platform.",
    "REMOVE_FILE": "Remove photo",
    "TAKE_PHOTO": "Take a photo",
    "TITLE": "Add product photos",
    "TITLE_ERROR_TOKEN_VALIDITY": "Expired or invalid link",
    "TITLE_SENT": "Your photos were added to the file"
  },
  "COMMENTARY_REPAIR_FILE": {
    "INFO_ALERT": "The Boomerang team is not alerted about your comments. To contact us, press Chat (green bubble at the bottom right)."
  },
  "INFORMATION_REPAIR_FILE": {
    "TRANSPORTER_MODALITY": {
      "TRANSPORTER": "Transporter",
      "WORKSHOP": "Workshop",
      "STORE": "Store",
      "EXCLUDING_SUPPORT": "Out of process"
    }
  },
  "COMMENTARY_RENTAL_FILE": {
    "INFO_ALERT": "The Boomerang team is not alerted about your comments. To contact us, press Chat (green bubble at the bottom right)."
  },
  "REPAIR_FILE_GLOBAL_INFO": {
    "STATUS_ACTION": {
      "VALIDATE_RECEIPT": "Validate receipt"
    },
    "REPAIR_FILE_INFO": {
      "TITLE": {
        "SUMMARY": "Summary",
        "PROGRESSION": "Progression",
        "PRICING": "Detailed pricing"
      },
      "SERIAL_NUMBER": "Series",
      "DESCRIPTION": "Description",
      "CONTACT": "Contact",
      "LASTNAME": "Contact name",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Phone",
      "WORKSITE_CODE": "Worksite code",
      "CLIENT_CODE": "Client code",
      "PRICING": "Pricing",
      "SUPPORT": "Support",
      "GESTION": "Management",
      "UNDER_GUARANTEE": "Under warranty",
      "OUT_GUARANTEE": "Out of warranty"
    }
  },
  "TRANSPORTER_REPAIR_FILE": {
    "TITLE": "Outbound/Return addresses",
    "PALLET": "Transport with pallet"
  },
  "RENTAL_FILE_GLOBAL_INFO": {
    "RENTAL_FILE_INFO": {
      "TITLE": {
        "SUMMARY": "Summary",
        "PRICING": "Detailed pricing"
      },
      "SERIAL_NUMBER": "Series",
      "DESCRIPTION": "Description",
      "CONTACT": "Contact",
      "LASTNAME": "Signatory name",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Phone"
    }
  },
  "KEY_ACCOUNT_PRODUCT_DETAIL_PAGE": {
    "BUTTON": {
      "ADD_PURCHASE_INVOICE": "Add purchase invoice"
    },
    "MESSAGE": {
      "PURCHASE_INVOICE_UPDATED": "Purchase invoice added."
    },
    "PURCHASE_INVOICE_MODAL": {
      "TITLE": "Add purchase invoice",
      "SUBTITLE": "One file only - PDF or image",
      "DROPZONE_TITLE": "Click or drop your invoice",
      "ACCEPTED_FORMATS": "PDF, JPG, PNG, WEBP",
      "TAKE_PHOTO": "Take a photo",
      "VALIDATE": "Add invoice"
    }
  }
}
